import $ from 'jquery'
import {getWxShareApi} from "@/service";

const wx = require('weixin-js-sdk')
const shareImg = require('@/assets/img/home/wxShare.jpg');
const baseUrl = process.env.VUE_APP_WXCODE
const preview = process.env.VUE_APP_PREVIEW
const wxShareUrl = process.env.VUE_APP_WXSHARE
// 地址
const locationPath = window.location.href
// const locationPath = window.location.href.split('#')[0]
// 微信分享
const url = `${wxShareUrl}/api/neo-system/thirdPart/auth/wx/config/noToken?url=` + encodeURIComponent(locationPath)
export const wxShareInit = async () => {

  // 微信分享
  const {result} = await getWxShareApi()

  const details = result
  wx.config({
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: details.appId, // 必填，公众号的唯一标识
    timestamp: details.timestamp, // 必填，生成签名的时间戳
    nonceStr: details.nonceStr, // 必填，生成签名的随机串
    signature: details.signature, // 必填，签名
    jsApiList: [
      // 必填，需要使用的JS接口列表
      'checkJsApi',
      'onMenuShareTimeline', // 分享到微信朋友圈
      'onMenuShareAppMessage', // 分享给微信朋友
      'onMenuShareQQ', // 分享到QQ
      'onMenuShareQZone', // 分享到QQ空间
      'updateAppMessageShareData', // 分享到微信及QQ（新接口）
      'updateTimelineShareData' // 分享到朋友圈”及“分享到QQ空间（新接口）
    ]
    // jsApiList: ['updateTimelineShareData', 'updateAppMessageShareData'], // 必填，需要使用的JS接口列表
    // jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage'], // 必填，需要使用的JS接口列表
  })
  wx.checkJsApi({
    jsApiList: ['chooseImage', 'updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareAppMessage'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
    success: function (res) {
      // 以键值对的形式返回，可用的api值true，不可用为false
      // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
      // alert("查看分享权限 checkJsApi:" + JSON.stringify(res))
    }
  });
    console.log('开始执行，分享主图:', shareImg)
}

export function wxShare(title, img, desc, type) {

  // 除了课题详情页 其它页面的分享主图都是  本地静态图片
  if (type) {
    img = baseUrl + img
  } else {
    img = preview + img
  }

  // 去除特殊符号
  const reg = /<[^>]+>/g

  title = title && title
    .replace(reg, '')
    .replaceAll('&ldquo;', '“')
    .replaceAll('&rdquo;', '”')
    .replaceAll('&quot;', '"')
    .replaceAll('&lt;', '<')
    .replaceAll('&gt;', '>')
    .replaceAll('&nbsp;', ' ')

  desc = desc && desc
    .replace(reg, '')
    .replaceAll('&ldquo;', '“')
    .replaceAll('&rdquo;', '”')
    .replaceAll('&quot;', '"')
    .replaceAll('&lt;', '<')
    .replaceAll('&gt;', '>')
    .replaceAll('&nbsp;', ' ')
      // 增加lodaing

  let locationPath = window.location.href
  wx.ready(function () {
    console.log('wx.ready')
    console.log(title, locationPath, img)

    const shareList = {
      title: title, // 分享标题
      link: locationPath, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: img, // 分享图标
      desc: desc, // 分享描述
      success: function () {
        console.log('success，分享主图:', shareImg)
      },
      error: function (ex) {
        console.log('error，分享主图:', shareImg)
        // alert('error:' + JSON.stringify(ex));
      },
      fail: function (ex) {
        console.log('fail，分享主图:', shareImg)
      }
    }

    wx.updateAppMessageShareData(shareList);

    wx.onMenuShareTimeline(shareList);

    wx.onMenuShareAppMessage(shareList);
    // 需在用户可能点击分享按钮前就先调用
    // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
    wx.updateTimelineShareData(shareList)

    console.log('执行结束， 分享主图:', shareImg)
  })
  wx.error(function (res) {
    console.log(JSON.stringify(res), 'wxErr信息')
  })
}
